import type {
  AxiosRequestConfig,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { webviewHttpClient } from '@/app/[locale]/(m)/components/auth/webview-http-client';

export interface DeleteRatingImageParams {
  order_code: string;
  image_url: string;
}

export const deleteRatingImageFn = async (
  token: string,
  params: DeleteRatingImageParams,
  config: AxiosRequestConfig = {}
): Promise<any> => {
  const response = await webviewHttpClient.delete<any>(
    apiRoutes.ahafood.web_view.delete_rating_image(params.order_code),
    {
      ...config,
      data: {
        image_url: params.image_url,
      },
      headers: {
        ...config.headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    }
  );

  return response.data;
};

export const useDeleteRatingImage = (
  token: string,
  options?: UseMutationOptions<any, DefaultQueryError, DeleteRatingImageParams>
) =>
  useMutation<any, DefaultQueryError, DeleteRatingImageParams>({
    mutationFn: (params) => deleteRatingImageFn(token, params),
    ...options,
  });

export interface DeleteRatingParams {
  order_code: string;
}

export const deleteRatingFn = async (
  token: string,
  params: DeleteRatingParams,
  config: AxiosRequestConfig = {}
): Promise<any> => {
  const response = await webviewHttpClient.delete<any>(
    apiRoutes.ahafood.web_view.delete_rating(params.order_code),
    {
      ...config,
      headers: {
        ...config.headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    }
  );

  return response.data;
};

export const useDeleteRating = (
  token: string,
  options?: UseMutationOptions<any, DefaultQueryError, DeleteRatingParams>
) =>
  useMutation<any, DefaultQueryError, DeleteRatingParams>({
    mutationFn: (params) => deleteRatingFn(token, params),
    ...options,
  });
